import type { Folha } from '../world/spriteAtlas';
import { tingirFonte } from './pele';

export const CABELO_MIN = 1102;
export const CABELO_MAX = 1149;
export const CABELO_PADRAO = 1102;
export const CABELO_DIVISOR = 246;
export const ESTILO_OK = /^[a-z0-9-]+$/;

const TINGIDAS_MAX = 24;
const tingidas = new Map<string, Folha>();
let tabela: Record<string, string> | null = null;
let aquecimento: Promise<void> | null = null;

export function estiloValido(raw: string | null | undefined): raw is string {
  return !!raw && raw !== 'none' && ESTILO_OK.test(raw);
}

export function cabeloHueValido(hue?: number): hue is number {
  return hue != null && hue >= CABELO_MIN && hue <= CABELO_MAX;
}

export function cabeloHueNoIntervalo(hue?: number): number {
  return cabeloHueValido(hue) ? hue : CABELO_PADRAO;
}

export function aquecerCabelo(): Promise<void> {
  if (tabela) return Promise.resolve();
  aquecimento ??= fetch('/cores/cabelo.json')
    .then(r => (r.ok ? r.json() : {}))
    .then((j: Record<string, string>) => { tabela = j && typeof j === 'object' ? j : {}; })
    .catch(() => { tabela = {}; });
  return aquecimento;
}

function hexParaRgb(hex: string): { r: number; g: number; b: number } {
  const n = Number.parseInt(hex.replace('#', ''), 16);
  if (!Number.isFinite(n)) return { r: 26, g: 18, b: 14 };
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

/** RGB da tabela `public/cores/cabelo.json`. Sem fetch, cai no preto 1102. */
export function corDoCabelo(hue: number): { r: number; g: number; b: number } {
  const h = cabeloHueNoIntervalo(hue);
  const hex = tabela?.[String(h)] ?? tabela?.[String(CABELO_PADRAO)] ?? '#1a120e';
  return hexParaRgb(hex);
}

/** Cor CSS da tabela cabelo.json. Chamar depois de aquecerCabelo(). */
export function cabeloCss(hue: number): string {
  const { r, g, b } = corDoCabelo(hue);
  return `rgb(${r} ${g} ${b})`;
}

function deveTingirCabelo(folha: Folha): boolean {
  return folha.url.includes('/hair/') || folha.url.includes('/beard/');
}

export function tingirFolhaCabelo(folha: Folha, hue: number): Folha {
  if (!deveTingirCabelo(folha)) return folha;
  const tom = cabeloHueNoIntervalo(hue);
  const key = `${folha.url}#cabelo${tom}#${folha.frames}`;
  const hit = tingidas.get(key);
  if (hit) {
    tingidas.delete(key);
    tingidas.set(key, hit);
    return hit.fps === folha.fps ? hit : { ...hit, fps: folha.fps };
  }
  let w = 0;
  let h = 0;
  for (const linha of folha.dirs) {
    for (const q of linha) {
      w = Math.max(w, q.sx + q.w);
      h = Math.max(h, q.sy + q.h);
    }
  }
  const fonte = tingirFonte(folha.fonte, w, h, corDoCabelo(tom), CABELO_DIVISOR);
  const next: Folha = {
    ...folha,
    url: key,
    fonte,
    dirs: folha.dirs.map(row => row.map(q => ({ ...q, fonte })))
  };
  tingidas.set(key, next);
  while (tingidas.size > TINGIDAS_MAX) {
    const velha = tingidas.keys().next();
    if (velha.done) break;
    tingidas.delete(velha.value);
  }
  return next;
}